import { CardInterface } from '@modules/card/interfaces/card.interface';
import { CardModel } from '@modules/card/models/card.model';

import { SectionType } from '../enums/section-type.enum';

import { Section } from './section.model';

export interface SquareSectionInterface {
  headline?: string;
  anchor?: string;
  teasers: CardInterface[];
  inverted?: boolean;
}

export class SquareSectionModel implements Section {
  public inverted = false;
  public type = SectionType.SQUARE;
  public teasers: CardModel[];
  public heroTeaser: CardModel;
  public headline?: string;
  public anchor?: string;

  constructor(data: SquareSectionInterface) {
    this.headline = data.headline;
    this.anchor = data.anchor;
    const _teasers = data.teasers.map((item) => new CardModel(item));
    this.inverted = !!data.inverted;
    const [heroTeaser, ...teasers] = _teasers;
    this.teasers = teasers;
    this.heroTeaser = heroTeaser;
  }
}
